import auth from "./modules/auth.json";
import common from "./modules/common.json";
import dashboard from "./modules/dashboard.json";
import nav from "./modules/nav.json";
import product from "./modules/product.json";
import bom from "./modules/bom.json";
import bol from "./modules/bol.json";
import emailTracking from "./modules/emailTracking.json";
// Merge all translations into a single object
const en = {
  ...auth,
  ...common,
  ...dashboard,
  ...nav,
  ...product,
  ...bom,
  ...bol,
  ...emailTracking,
};

export default en;
